"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualizedMenuList = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var react_virtualized_1 = require("react-virtualized");
var DEFAULT_MAX_HEIGHT = 1200;
exports.VirtualizedMenuList = function (props) {
    var _a = props.selectProps, id = _a.id, maxMenuHeight = _a.maxMenuHeight, children = props.children;
    var childrenArray = react_1.default.Children.toArray(children);
    var cache = new react_virtualized_1.CellMeasurerCache({
        defaultHeight: 50,
        fixedWidth: true,
    });
    var maxHeight = maxMenuHeight && typeof maxMenuHeight === 'number'
        ? maxMenuHeight
        : DEFAULT_MAX_HEIGHT;
    var rowRenderer = function (_a) {
        var index = _a.index, key = _a.key, parent = _a.parent, style = _a.style;
        return (react_1.default.createElement(react_virtualized_1.CellMeasurer, { cache: cache, columnIndex: 0, key: key, parent: parent, rowIndex: index }, function (_a) {
            var measure = _a.measure;
            return (react_1.default.createElement("div", { key: index, style: style, onLoad: measure }, childrenArray[index]));
        }));
    };
    return (react_1.default.createElement(StyledDiv, null,
        react_1.default.createElement(react_virtualized_1.AutoSizer, { disableHeight: true }, function (_a) {
            var width = _a.width;
            return (react_1.default.createElement(react_virtualized_1.List, { height: maxHeight, rowRenderer: rowRenderer, rowHeight: cache.rowHeight, rowCount: childrenArray.length, width: width }));
        })));
};
exports.VirtualizedMenuList.displayName = 'FOS_ReactSelect_MenuList';
var StyledDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  li {\n    list-style: none;\n  }\n  height: 100%;\n"], ["\n  li {\n    list-style: none;\n  }\n  height: 100%;\n"])));
var templateObject_1;
